import { gql } from '@apollo/client';

export const COLINK_EXIST = gql`
  query ($stashlinkId: ID!) {
    hasColinkedBefore(
      stashlinkId: $stashlinkId
    )
  }
`;
